module.exports = __webpack_public_path__ + "static/media/logo_da.4b0852ba.svg";